import { useEffect, useState } from 'react';
import { getEnhancedAddress } from '../api/addressService';
import { toDisplayAddress, DisplayAddress } from '../utils/addressDisplay';

export interface ContextAddressLike {
  addressId?: string;
  mainAddress?: string;
  detailAddress?: string;
  stay?: { display_info?: string };
}

const legacyOf = (a: ContextAddressLike | null): string | undefined =>
  a?.stay?.display_info || a?.mainAddress || undefined;

export const useDisplayAddress = (address: ContextAddressLike | null): DisplayAddress => {
  const [display, setDisplay] = useState<DisplayAddress>(() =>
    toDisplayAddress({ detail: address?.detailAddress, legacy: legacyOf(address) })
  );

  const addressId = address?.addressId;
  const detailAddress = address?.detailAddress;
  const legacy = legacyOf(address);

  useEffect(() => {
    // 우선 폴백으로 즉시 렌더
    setDisplay(toDisplayAddress({ detail: detailAddress, legacy }));

    if (!addressId) {
      return;
    }

    let cancelled = false;
    getEnhancedAddress(addressId)
      .then((enh) => {
        if (cancelled) return;
        setDisplay(
          toDisplayAddress({
            roadAddressEn: enh.roadAddressEn,
            jibunAddressEn: enh.jibunAddressEn,
            detail: enh.detailAddress || detailAddress,
            legacy,
          })
        );
      })
      .catch(() => {
        /* 폴백 유지 */
      });

    return () => {
      cancelled = true;
    };
  }, [addressId, detailAddress, legacy]);

  return display;
};
